import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center">
    <div className="grid grid-cols-4 gap-1">
      {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
        <div key={i} className="w-4 h-4 bg-zinc-200 dark:bg-zinc-700 rounded-sm" />
      ))}
    </div>
  </div>
);

export default Thumbnail;
